import { render } from "./V12StyleBottom.vue?vue&type=template&id=4e8cff7a&scoped=true"
import script from "./V12StyleBottom.vue?vue&type=script&lang=js"
export * from "./V12StyleBottom.vue?vue&type=script&lang=js"

import "./V12StyleBottom.vue?vue&type=style&index=0&id=4e8cff7a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e8cff7a"]])

export default __exports__